import { render, staticRenderFns } from "./SitemapSectionModule.vue?vue&type=template&id=4d543d5c&"
import script from "./SitemapSectionModule.vue?vue&type=script&lang=js&"
export * from "./SitemapSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports